import styled, { css } from 'styled-components';

export const PlataformaAberta = styled.section`
  background: #e9ebed;
  &:nth-child(odd) {
    > div {
      > img {
        order: 1;
        ${({ theme }) => {
          return (
            theme &&
            css`
              @media (max-width: ${theme.breakpoints.medium}) {
                order: 2;
              }
            `
          );
        }}
      }
      .text {
        order: 2;
        ${({ theme }) => {
          return (
            theme &&
            css`
              @media (max-width: ${theme.breakpoints.medium}) {
                order: 1;
              }
            `
          );
        }}
      }
    }
  }
  > div {
    align-items: center;
    display: flex;
    justify-content: space-between;
    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            flex-wrap: wrap;
          }
        `
      );
    }}
    > img {
      width: calc(50% - (30px * 3));
      ${({ theme }) => {
        return (
          theme &&
          css`
            @media (max-width: ${theme.breakpoints.medium}) {
              width: 100%;
              margin-top: 30px;
            }
          `
        );
      }}
    }
    .text {
      width: 50%;
      ${({ theme }) => {
        return (
          theme &&
          css`
            @media (max-width: ${theme.breakpoints.medium}) {
              width: 100%;
            }
          `
        );
      }}
      h3 {
        margin-bottom: 30px;
      }
      .icon {
        height: 25px;
        margin-right: 15px;
        width: 15px;
        circle {
          fill: #364ef7;
        }
        path {
          fill: none;
          stroke: #fff;
          stroke-width: 2px;
        }
      }
      ul {
        align-items: flex-start;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-bottom: 30px;
        margin-top: 30px;
        ${({ theme }) => {
          return (
            theme &&
            css`
              @media (max-width: ${theme.breakpoints.medium}) {
                margin-top: calc(30px / 2);
                margin-bottom: calc(30px / 2);
              }
            `
          );
        }}
        li {
          width: 50%;
          ${({ theme }) => {
            return (
              theme &&
              css`
                @media (max-width: ${theme.breakpoints.medium}) {
                  width: 100%;
                }
              `
            );
          }}
        }
      }
      .info {
        align-items: flex-start;
        display: flex;
        justify-content: flex-start;
        margin-top: calc(30px / 2);
        svg {
          margin-right: calc(30px / 2);
          width: 15px;
        }
        p {
          width: calc(100% - 30px);
        }
      }
    }
  }
`;

export const Container = styled.div`
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 80px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          padding: 0 16px;
          flex-direction: column;
        }
      `
    );
  }}
`;
